/** @jsx jsx */
import { Children, memo } from "react";
import ReactMasonry from "react-masonry-css";
import { jsx } from "theme-ui";
import useTheme from "../../useTheme";
var GUTTER = 4;

var Masonry = function Masonry(_a) {
  var _b;

  var _c = _a.maxCols,
      maxCols = _c === void 0 ? 2 : _c,
      _d = _a.padding,
      padding = _d === void 0 ? 0 : _d,
      children = _a.children;
  var theme = useTheme().theme; // We assume that theme breakpoints are always set in pixels.

  var minBreakpoint = theme.breakpoints ? parseInt(String(theme.breakpoints[0])) : 576;
  var childrenArray = Children.toArray(children);
  return jsx(ReactMasonry, {
    breakpointCols: (_b = {
      default: maxCols
    }, _b[minBreakpoint] = 1, _b),
    className: "masonry",
    columnClassName: "masonry-column",
    sx: {
      "&.masonry": {
        display: "flex",
        marginLeft: -GUTTER,
        width: "auto",
        padding: padding,
        ".masonry-column": {
          paddingLeft: GUTTER
        }
      }
    }
  }, childrenArray.map(function (child, i) {
    return jsx("div", {
      key: i,
      sx: {
        marginBottom: GUTTER
      }
    }, child);
  }));
};

export default memo(Masonry);